
   $( function() {
$(".product-options-single-size li").on('click', function(){
     var size = $(this).text();
    $(this).parent().siblings().children("span").empty().text(size);
    $(this).parent().siblings().children("span").attr("size-data",size);
$(".product-options-single-size").removeClass("active")
  var Diameterinch = parseInt($(this).text());

      switch(Diameterinch){
        case 20 :
      $(".block-swatch-20Inch").click();       
          break;
case 22 :
      $(".block-swatch-22Inch").click();
          break;
case 24 :
          $(".block-swatch-24Inch").click();
          break;
case 26 :
           $(".block-swatch-26Inch").click();
          break;
          case 27 :
           $(".block-swatch-27Inch").click();
          break;
case 28 :
            $(".block-swatch-28Inch").click();
          break;
case 30 :
         $(".block-swatch-30Inch").click();
          break;
          case 31 :
         $(".block-swatch-31Inch").click();
          break;
case 32 :
      $(".block-swatch-32Inch").click();
          break;
case 34 :
            $(".block-swatch-34Inch").click();
          break;
          case 35 :
            $(".block-swatch-35Inch").click();
          break;
case 36 :
          $(".block-swatch-36Inch").click(); 
          break;
case 38 :
          $(".block-swatch-38Inch").click();
          break;
          case 39 :
            $(".block-swatch-39Inch").click();
          break;
case 40 :
         $(".block-swatch-40Inch").click(); 
          break;
case 42 :
           $(".block-swatch-42Inch").click();
          break;
case 44 :
       $(".block-swatch-44Inch").click();
          break;
case 46 :
           $(".block-swatch-46Inch").click();    
          break;
case 48 :
               $(".block-swatch-48Inch").click();
          break;
case 50 :
               $(".block-swatch-50Inch").click();    
          break;
      }

if (Diameterinch < 20) {
  $(".custom-option-select-mirror").addClass("no-drop");
  $(".product-options-label-mirror span").text("Select");
  $('.makeup-mirror input').val("").attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
} else {
  $(".custom-option-select-mirror").removeClass("no-drop");
}

if (Diameterinch < 20) {
  $(".custom-option-select-wifi, .custom-option-select-bluetooth, .custom-option-select-demister, .custom-option-select-clock").addClass("no-drop");
  $(".product-options-label-wifi span, .product-options-label-bluetooth  span, .product-options-label-demister  span, .product-options-label-clock span").text("Select");
  $('.clock-wifi input, .bluetooth-speaker input, .demister input, .clock input').val("").attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
} else {
  $(".custom-option-select-clock, .custom-option-select-wifi, .custom-option-select-bluetooth, .custom-option-select-demister").removeClass("no-drop");
}

if (Diameterinch >= 80) {
  $(".product-options-single-rush").removeClass("product-options-single").addClass("product-options-single-rush-no");
  $(".product-options-label-rush span").text("Select");
  $(".options-single-rush-p").css("color", "#b9083a");
  $('.delivery input').val("").attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
} else {
  $(".product-options-single-rush").addClass("product-options-single").removeClass("product-options-single-rush-no");
  $(".options-single-rush-p").css("color", "#a9a9a9");
}


  
})






$(".product-options-label").on('click', function(){
    $(this).children(".icon--chevron").toggleClass("ico-rotate")
    $(this).siblings().toggleClass("active");
     $(this).parent().parent().siblings().children().children(".product-options-content").removeClass("active");
  })

  $(".product-options-single").on('click', function(){
  $(".product-options-content").removeClass("active");
 $(".icon--chevron").removeClass("ico-rotate");
 var val = $(this).attr("data-val");
var pricei = $(this).attr("data-price");  
var vall = val + '\xa0' +'\xa0' + pricei;
  if (typeof(pricei)=="undefined" ){
$(this).parent().siblings().children("span").empty().text(val);
  }else{
 $(this).parent().siblings().children("span").empty().text(vall);   
  }  
var attr = $(this).parent().siblings().attr("data-attr");   
 switch(attr){
       case ("Mirror Edge Craftsmanship"):
   if(String(val).toLowerCase() == 'none'){ 
 $('.mirror-edge input').val(val).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
   }else{
 $('.mirror-edge input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
   }
 break;
     
  case ("Color Temperature"):
   var colorPrice = typeof pricei === 'string' ? Number(pricei.replace(/[^0-9\.-]+/g,"")) : 0;
   $('.color-temperature input').val(val).attr('ymq-option-price', colorPrice).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
 break;
     
  case ("Illumination Switch"):
     if( val == "Touch Switch"){
 $('.Illumination-switch input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
     } else{    
 $('.Illumination-switch input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
     }
 break;
     
   case ("Adapter"):
 $('.adapter input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
 break;

   case ("Backlight"):
     if(String(val).toLowerCase() == "none"){
 $('.backlight input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
     } else{
 $('.backlight input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
     }
 break;

        case ("Frame"):
     if ($(this).data('price')) {
    $('.frame input').val(val).attr('ymq-option-price', Number(pricei.replace(/[^0-9\.-]+/g, ""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
} else {
    $('.frame input').val(val).attr('ymq-option-price', 0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}
 break;

  case ("Demister"):
if(String(val).toLowerCase() == "none"){
 $('.demister input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}else{
  $('.demister input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); }); 
}
 break;

  case ("Makeup Mirror"):
if(String(val).toLowerCase() == "none"){
   $('.makeup-mirror input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}else{
   $('.makeup-mirror input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}

 break;

  case ("Bluetooth Speaker"):
     if(String(val).toLowerCase() == "none"){
 $('.bluetooth-speaker input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}else{
 $('.bluetooth-speaker input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
  }
 break;

  case ("Clock / Wi-Fi Weather Station"):
if(String(val).toLowerCase() == "none"){
   $('.clock-wifi input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}else {
   $('.clock-wifi input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}   
 break;

  case ("Clock"):
if(String(val).toLowerCase() == "none"){
   $('.clock input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}else {
   $('.clock input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}   
 break;

  
 case ("Delivery Time"):
var Widthinch =  parseInt($(".diameterSize-inch").text());
if( val == "Free Standard Delivery (8–10 Weeks)"){
 $('.delivery input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
  $(".option-pickup-point").addClass("hidden");
  
}else if ( val == "Express Shipping (5–6 Weeks)") { 
  $(".option-pickup-point").addClass("hidden");
if( Widthinch >= 80 ){
   $(this).parent().siblings().children("span").empty().text("Free Standard Delivery (8–10 Weeks)"); 
 $('.delivery input').val( "Free Standard Delivery (8–10 Weeks)" ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); }); 
}else{
 $('.delivery input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}
  }
 break;      
   }

       
  })     


      $(".product-options-label-delivery>.product-options-single").on('click', function(){
$(this).parent().siblings().removeClass("border-cuistom").parent().siblings().removeClass("font-cuistom")
var val = $(this).attr("data-val");
if ( val == "Free Standard Delivery (8–10 Weeks)" || val == "Express Shipping (5–6 Weeks)" ){

   $(".flase-add-to-cart").addClass("hidden")
$("#AddToCart").removeClass("hidden")
    $(".add-flase-p").addClass("hidden"); 

}else{
$(".flase-add-to-cart").removeClass("hidden")
$("#AddToCart").addClass("hidden")
 $(".add-flase-p").removeClass("hidden"); 

  
}
  }) 


   var ico = `<div class="option-label-i-ico">More information</div>`;
 $(".option-label-i").hover(function(){
           $(this).append(ico);
    }, function() {  
  $(".option-label-i-ico").remove();
   }) 

   $(".option-label-i").on('click', function(){
     $(this).siblings(".option-label-i-content").addClass("active");
         $(".option-label-i-content").hover(function(){
    }, function() {  
     $(this).removeClass("active")
   }) 
  }) 
   $(".option-label-i-content span").on('click', function(){
     $(".option-label-i-content").removeClass("active")
  }) 

  $(".flase-add-to-cart").on('click', function(){
$(".add-flase-p").removeClass("hidden");
  var del = $(".false-deliviry").text();   
    if ( del== "Select" ){
  $(".false-deliviry").parent().addClass("border-cuistom").parent().siblings().addClass("font-cuistom")
}
 })

      })
